import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import {
  createProvider,
  deleteProvider,
  updateProvider,
} from "../../utils/provider";
import { db } from "../../index";
import styled from "styled-components";
import { NavItem, NavTabs } from "../layout/Nav";
import { Accordion, Form } from "react-bootstrap";
import { FooterActionsContainer } from "../layout/Footer";
import { OutlineButton } from "../layout/OutlineButton";
import { useTarifsOptions } from "../../utils/estimate-invoice";

function ContactForm({ contact, index, setProvider }) {
  function handleChange(e) {
    const field = e.target.name;
    const value = e.target.value;

    setProvider((old) => {
      const newContacts = [...old.contacts];
      newContacts[index][field] = value;
      return {
        ...old,
        contacts: newContacts,
      };
    });
  }

  function deleteContact(e) {
    e.preventDefault();
    setProvider((old) => {
      const newContacts = [...old.contacts];
      newContacts.splice(index, 1);
      return {
        ...old,
        contacts: newContacts,
      };
    });
  }

  return (
    <div>
      <div className="row">
        <label className="col-lg-3 col-form-label">Nom:</label>
        <label className="col-lg-3 col-form-label">Téléphone:</label>
        <label className="col-lg-3 col-form-label">Email:</label>
        <label className="col-lg-3 col-form-label">Fonction:</label>
      </div>
      <div key={index} className="form-group row">
        <div className="col-lg-3">
          <input
            type="text"
            className="form-control"
            name="name"
            value={contact.name}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3">
          <input
            type="tel"
            className="form-control"
            name="phone"
            value={contact.phone}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3">
          <input
            type="email"
            className="form-control"
            name="email"
            value={contact.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3">
          <input
            type="text"
            className="form-control"
            name="role"
            value={contact.role}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-2 mt-1">
          <button
            type="button"
            className="btn btn-danger"
            onClick={deleteContact}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}

const CheckboxGridContainer = styled.div`
  width: max-content;
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr;
  justify-items: center;
  column-gap: 10px;
  row-gap: 16px;

  & > *:nth-child(4n + 1) {
    justify-self: start;
  }
`;

function NotificationLineCheckboxes({ provider, label, field, setProvider }) {
  function updateCheckbox(e, contactField) {
    setProvider((old) => {
      let result = { ...old };
      if (!result["forbiddenNotifications"]) {
        result["forbiddenNotifications"] = {};
      }

      if (!result["forbiddenNotifications"][field]) {
        result["forbiddenNotifications"][field] = {};
      }

      return {
        ...result,
        forbiddenNotifications: {
          ...result["forbiddenNotifications"],
          [field]: {
            ...result["forbiddenNotifications"][field],
            [contactField]: !e.target.checked,
          },
        },
      };
    });
  }

  function getValue(contactField) {
    if (
      !provider.forbiddenNotifications ||
      !provider.forbiddenNotifications[field]
    ) {
      return true;
    }
    return !provider.forbiddenNotifications[field][contactField];
  }

  return (
    <>
      <label className="form-check-label">{label}</label>
      <input
        type="checkbox"
        name={`${field}EmailCheckbox-Provider`}
        id={`${field}EmailCheckbox-Provider`}
        checked={getValue("provider")}
        onChange={(e) => updateCheckbox(e, "provider")}
      />
      <input
        type="checkbox"
        name={`${field}EmailCheckbox-Passenger`}
        id={`${field}EmailCheckbox-Passenger`}
        checked={getValue("passenger")}
        onChange={(e) => updateCheckbox(e, "passenger")}
      />
      <input
        type="checkbox"
        name={`${field}EmailCheckbox-Contact`}
        id={`${field}EmailCheckbox-Contact`}
        checked={getValue("contact")}
        onChange={(e) => updateCheckbox(e, "contact")}
      />
    </>
  );
}

// region notifications constants

const defaultNotificationText = {
  bookingCancellationMail: {
    EN: `We confirm that we have cancelled the reservation below.
If a payment has been made, you should receive the refund directly to the card you used to purchase. If you have any questions or would like to reorder, please let use know !`,
    FR: `Nous vous confirmons avoir annulé la réservation ci-dessous.
Si un paiement a été effectué, vous devriez recevoir le remboursement directement sur la carte utilisée pour l'achat. Si vous avez des questions ou souhaitez repasser commande, n'hésitez pas à nous le faire savoir !`
  },
  driverDetailsMail: {
    EN: `Greetings,`,
    FR: `Bonjour,`
  },
  driverDetailsWhatsapp: {
    EN: `Greetings,`,
    FR: `Bonjour,`
  },
  bookingUpdateMail: {
    EN: `Your booking has been updated`,
    FR: `Votre réservation a été mise à jour`
  },
  bookingConfirmationMail: {
    EN: `Thank you again for booking with us.`,
    FR: `Merci de nous avoir fait confiance pour votre réservation.`
  },
};

const notificationPrefixText = {
  bookingCancellationMail: "Dear [passenger_name],",
  bookingConfirmationMail: "Dear [passenger_name],",
  driverDetailsMail: ``,
  driverDetailsWhatsapp: ``,
  bookingUpdateMail: ``,
};

const notificationSuffixText = {
  bookingCancellationMail: (
    <div>
      <ul>
        <li>
          <strong>Name:</strong> [passenger_name]
        </li>
        <li>
          <strong>Passengers:</strong> [nb_passenger]
        </li>
        <li>
          <strong>Bags:</strong> [nb_bags]
        </li>
        <li>
          <strong>Vehicle:</strong> [vehicle]
        </li>
        <li>
          <strong>Pickup Time:</strong> [pickup_time]
        </li>
        <li>
          <strong>Pickup Address: [pickup_address]</strong>
        </li>
        <li>
          <strong>Full Pickup Address:</strong> [pickup_full_address]
        </li>
        <br />
        <li>
          <strong>Dropoff Address:</strong> [dropoff_address]
        </li>
        <li>
          <strong>Full Dropoff Address:</strong> [dropoff_full_address]
        </li>
        <li>
          <strong>Flight or Train Number + Departure City:</strong> [flight_nb]
        </li>
        <li>
          <strong>Informations:</strong> [additional_info]
        </li>
        <li>
          <strong>Estimated Distance:</strong> [distance_and_duration]
        </li>
        <li>
          <strong>Phone Number:</strong> [passenger_phone]
        </li>
        <li>
          <strong>Email:</strong> [passenger_email]
        </li>
        <li>
          <strong>Trip Type:</strong> [trip_type]
        </li>
      </ul>
      <p>
        We hope to drive you soon.
        <br />
        Best regards
        <br />
        The [user_company_name] team
        <br />
        <br />
        [user_company_email]
      </p>
    </div>
  ),
  bookingConfirmationMail: (
    <div>
      <p>
        <strong>Booking n°:</strong> [id]
        <br />
        <strong>Name:</strong> [passenger_name]
        <br />
        <strong>Pickup Date & Time:</strong> [pickup_time]
        <br />
        <strong>Pickup Address:</strong> [pickup_address]
        <br />
        <strong>Destination Address:</strong> [dropoff_address]
        <br />
        <strong>Vehicle:</strong> [vehicle]
        <br />
        <strong>Passengers:</strong> [nb_passenger]
        <br />
        <strong>Bags:</strong> [nb_bags]
        <br />
        <strong>Informations:</strong> [additional_info]
        <br />
        <br />
        Best regards,
        <br />
        [logoUrl]
      </p>
    </div>
  ),
  driverDetailsMail: (
    <div>
      <p>
        Your driver is [driver_name] ([driver_phone]) for the booking below:
      </p>
      <ul>
        <li>
          <strong>Pickup Date:</strong> [pickup_date]
        </li>
        <li>
          <strong>Pickup Time:</strong> [pickup_time]
        </li>
        <li>
          <strong>Pickup Address:</strong> [pickup_address]
        </li>
        <li><br/>
        </li>
        <li>
          <strong>Vehicle:</strong> [vehicle]
        </li>
      </ul>
      Best regards
      <br />
      The [user_company_name] team
      <br />
      <br />
      [user_company_email]
    </div>
  ),
  driverDetailsWhatsapp: (
    <div>
      Your driver is [driver_name] [driver_phone]
      <br />
      Car: [vehicle_type]
      <br />
      Track your driver: [tracking_link]
      <br />
    </div>
  ),
  bookingUpdateMail: (
    <div>
      See details below:
      <br />
      <br />
      <ul>
        <li>
          <strong>Booking id:</strong> [id]
        </li>
        <li>
          <strong>Name:</strong> [passenger_name]
        </li>
        <li>
          <strong>Passengers:</strong> [nb_passenger]
        </li>
        <li>
          <strong>Bags:</strong> [nb_bags]
        </li>
        <li>
          <strong>Vehicle:</strong> [vehicle]
        </li>
        <li>
          <strong>Pickup Time:</strong> [pickup_time]
        </li>
        <li>
          <strong>Pickup Address: [pickup_address]</strong>
        </li>
        <li>
          <strong>Full Pickup Address:</strong> [pickup_full_address]
        </li>
        <li>
          <strong>Step to:</strong> [step_address]
        </li>
        <br />
        <li>
          <strong>Dropoff Address:</strong> [dropoff_address]
        </li>
        <li>
          <strong>Full Dropoff Address:</strong> [dropoff_full_address]
        </li>
        <li>
          <strong>Flight or Train Number + Departure City:</strong> [flight_nb]
        </li>
        <li>
          <strong>Informations:</strong> [additional_info]
        </li>
        <li>
          <strong>Estimated Distance:</strong> [distance_and_duration]
        </li>
        <li>
          <strong>Phone Number:</strong> [passenger_phone]
        </li>
        <li>
          <strong>Trip Type:</strong> [trip_type]
        </li>
      </ul>
      Best regards
      <br />
      The [user_company_name] team
      <br />
      <br />
      [user_company_email]
    </div>
  ),
};

const clientNotifications = [
  {
    label: "[Mail] Confirmation de réservation",
    field: "bookingConfirmationMail",
  },
  {
    label: "[Mail] Mise à jour de la réservation",
    field: "bookingUpdateMail",
  },
  {
    label: "[Mail] Annulation de la réservation",
    field: "bookingCancellationMail",
  },
  {
    label: "[Mail] Informations du chauffeur",
    field: "driverDetailsMail",
  },
  {
    label: "[Whatsapp] Informations du chauffeur",
    field: "driverDetailsWhatsapp",
  }
];

// endregion

export default function ProviderAddOrUpdateContent({ onCreated } = {}) {
  const history = useHistory();
  const params = useParams();
  const providerId = params.provider_id;

  const { userInfos } = useContext(UserContext);
  const tarifOptions = useTarifsOptions();

  const [isFetching, setIsFetching] = useState(false);
  const [formError, setFormError] = useState([]);

  const [activeTab, setActiveTab] = useState(0);

  const [provider, setProvider] = useState({
    name: "",
    email: "",
    tel: "",
    vat_number: "",
    country: "",
    city: "",
    zip: "",
    adresse: "",
    tarif: "",
    detailedInvoice: false,
    bookingsSummaryMail: false,
    contacts: [],
    forbiddenNotifications: {},
    customization: {
      ...defaultNotificationText,
    },
  });

  useEffect(() => {
    if (providerId && userInfos?.uid) {
      db.ref(`users/${userInfos.uid}/provider/${providerId}`)
        .once("value", (snapshot) => {
          let res = snapshot.val();
          if (!res.customization) res.customization = {};
          setProvider({
            ...res,
            customization: { ...defaultNotificationText, ...res.customization },
            id: snapshot.key,
          });
        })
        .then();
    }
  }, [providerId, userInfos?.uid]);

  function handleChange(e) {
    const { name, value } = e.target;
    setProvider((old) => {
      if (name === "firstname") {
        return {
          ...old,
          [name]: value,
          name: `${value} ${old.lastname}`,
        };
      } else if (name === "lastname") {
        return {
          ...old,
          [name]: value,
          name: `${old.firstname} ${value}`,
        };
      }

      return {
        ...old,
        [name]: value,
      };
    });
  }

  function handleTemplateChange(e, field, language) {
    setProvider((old) => {
      let result = { ...old };
      if (!old.customization) {
        result.customization = {};
      } else {
        result.customization = { ...old.customization };
      }

      // Initialize the field as an object if it doesn't exist or is a string
      if (!result.customization[field] || typeof result.customization[field] === 'string') {
        const existingValue = typeof old.customization[field] === 'string' ? old.customization[field] : "";
        result.customization[field] = { EN: existingValue, FR: "" };
      }

      // Update the specific language
      result.customization[field][language] = e.target.value;

      return result;
    });
  }

  async function handleDeleteProvider() {
    await deleteProvider(userInfos, providerId);
    history.push("/provider");
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (handleValidation()) {
      setIsFetching(true);

      // Ensure all customization fields are objects with EN/FR keys
      const normalizedProvider = { ...provider };
      if (normalizedProvider.customization) {
        Object.keys(normalizedProvider.customization).forEach(field => {
          const value = normalizedProvider.customization[field];
          if (typeof value === 'string' && value.trim() !== '') {
            // Convert string to object with EN key, use default FR
            normalizedProvider.customization[field] = {
              EN: value,
              FR: defaultNotificationText[field]?.FR || ""
            };
          }
        });
      }

      if (providerId) {
        await updateProvider(userInfos, normalizedProvider);
        window.alert("Client mis à jour avec succès");
        if (onCreated) onCreated(normalizedProvider);
      } else {
        await createProvider(userInfos, normalizedProvider);
        if (onCreated) onCreated(normalizedProvider);
        else history.push("/provider");
      }

      setIsFetching(false);
    }
  }

  function handleValidation() {
    let valid = true;
    let message = [];

    if (!provider?.tel?.trim()) {
      valid = false;
      message.push("Veuillez renseigner le téléphone");
    }

    if (!provider?.email?.trim()) {
      valid = false;
      message.push("Veuillez renseigner l'email");
    }

    if (provider.isIndividual) {
      if (!provider?.firstname?.trim()) {
        valid = false;
        message.push("Veuillez renseigner le prénom");
      }

      if (!provider?.lastname?.trim()) {
        valid = false;
        message.push("Veuillez renseigner le nom");
      }
    } else {
      if (!provider?.name?.trim()) {
        valid = false;
        message.push("Veuillez renseigner la raison sociale");
      }

      // if (!provider?.vat_number?.trim()) {
      //   valid = false;
      //   message.push("Veuillez renseigner le numéro de TVA");
      // }
      if (!provider?.country?.trim()) {
        valid = false;
        message.push("Veuillez renseigner le pays");
      }
      if (!provider?.city?.trim()) {
        valid = false;
        message.push("Veuillez renseigner la ville");
      }
      if (!provider?.zip?.trim()) {
        valid = false;
        message.push("Veuillez renseigner le code postal");
      }
      if (!provider?.adresse?.trim()) {
        valid = false;
        message.push("Veuillez renseigner l'adresse");
      }

      if (
        provider?.contacts?.some((contact) => {
          return (
            contact.name === "" ||
            contact.phone === "" ||
            contact.email === "" ||
            contact.role === ""
          );
        })
      ) {
        valid = false;
        message.push("Veuillez renseigner tous les champs des contacts");
      }
    }

    setFormError(message);

    return valid;
  }

  const FormAlert = useMemo(() => {
    const alert =
      formError.length > 0 ? (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ flexDirection: "column" }}
        >
          {formError.map((error, index) => {
            return (
              <div
                className="alert-text"
                key={index}
                style={{ alignSelf: "flex-start" }}
              >
                {error}
              </div>
            );
          })}
        </div>
      ) : (
        ""
      );

    return (
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        {alert}
      </div>
    );
  }, [formError]);

  const buttonText =
    isFetching === true ? (
      <button type="submit" className="btn btn-primary px-5" disabled>
        {providerId ? "Mise à jour..." : "Création..."}
      </button>
    ) : (
      <button type="submit" className="btn btn-primary px-5">
        {providerId ? "Mettre à jour le client" : "Créer le client"}
      </button>
    );

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {providerId ? provider?.name : "Ajouter un client"}{" "}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/provider/" className="kt-subheader__breadcrumbs-link">
                Clients
              </Link>
              {providerId ? (
                <>
                  <span className="kt-subheader__breadcrumbs-separator"></span>
                  <Link
                    to={"/provider/" + providerId}
                    className="kt-subheader__breadcrumbs-link"
                  >
                    {provider.name}
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {FormAlert}

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label d-flex align-items-center">
              <NavTabs className="titles" style={{ marginTop: "1rem" }}>
                <NavItem className={activeTab === 0 ? "active" : ""}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(0);
                    }}
                  >
                    Données du client
                  </button>
                </NavItem>
                <NavItem className={activeTab === 1 ? "active" : ""}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(1);
                    }}
                  >
                    Notifications
                  </button>
                </NavItem>
              </NavTabs>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            {activeTab === 0 && (
              <div className="kt-portlet__body">
                <div className="kt-section kt-section--first">
                  <div className="kt-section__body">
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Statut :
                      </label>
                      <div className="col-lg-6 d-flex gap-4">
                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="is-individual"
                            id="is-individual-false"
                            value={false}
                            checked={!provider.isIndividual}
                            disabled={!!providerId}
                            onChange={(e) => {
                              setProvider((old) => ({
                                ...old,
                                isIndividual: !e.target.checked,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="is-individual-false"
                          >
                            Entreprise
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="is-individual"
                            id="is-individual-true"
                            value={true}
                            checked={provider.isIndividual}
                            disabled={!!providerId}
                            onChange={(e) => {
                              setProvider((old) => ({
                                ...old,
                                isIndividual: e.target.checked,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="is-individual-true"
                          >
                            Particulier
                          </label>
                        </div>
                      </div>
                    </div>
                    {provider.isIndividual ? (
                      <>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Prénom *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="firstname"
                              value={provider.firstname}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Nom *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="lastname"
                              value={provider.lastname}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="form-group row">
                        <label className="col-lg-3 col-form-label">
                          Raison Sociale *:
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={provider.name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Email *:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={provider.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Téléphone *:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="tel"
                          className="form-control"
                          name="tel"
                          value={provider.tel}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    {!provider.isIndividual && (
                      <>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Numéro de TVA :
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="vat_number"
                              value={provider.vat_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Pays *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="country"
                              value={provider.country}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Ville *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={provider.city}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Code Postal *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="zip"
                              value={provider.zip}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">
                            Adresse *:
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              name="adresse"
                              value={provider.adresse}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label">Tarif:</label>
                          <div className="col-lg-6">
                            <select
                              name="tarif"
                              className="form-control"
                              value={provider.tarif}
                              onChange={handleChange}
                            >
                              <option value="">Sélectionnez le tarif</option>
                              {tarifOptions.map((option) => (
                                <option
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <h4>Contacts</h4>
                        {provider?.contacts?.map((contact, index) => {
                          return (
                            <ContactForm
                              contact={contact}
                              index={index}
                              setProvider={setProvider}
                              key={`additional-contact-${index}`}
                            />
                          );
                        })}
                        <button
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            setProvider((old) => {
                              return {
                                ...old,
                                contacts: [
                                  ...(old?.contacts || []),
                                  { name: "", tel: "", email: "", role: "" },
                                ],
                              };
                            });
                          }}
                        >
                          Ajouter un contact
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {activeTab === 1 && (
              <div className="kt-portlet__body">
                <div className="kt-section kt-section--first">
                  <div className="kt-section__body">
                    <h4>Envois</h4>
                    <div className="form-group row mt-4">
                      <div>
                        <div className="form-check col-lg-6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="detailedInvoice"
                            id="detailed-invoice-checkbox"
                            checked={provider.detailedInvoice}
                            onChange={(e) => {
                              setProvider((old) => ({
                                ...old,
                                detailedInvoice: e.target.checked,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="detailed-invoice-checkbox"
                          >
                            Envoyer des factures détaillées
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mt-4">
                      <div>
                        <div className="form-check col-lg-6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="bookingsSummaryMail"
                            id="bookings-summary-mail-checkbox"
                            checked={provider.bookingsSummaryMail}
                            onChange={(e) => {
                              setProvider((old) => ({
                                ...old,
                                bookingsSummaryMail: e.target.checked,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="bookings-summary-mail-checkbox"
                          >
                            Envoyer un résumé quotidien des bookings à venir
                          </label>
                        </div>
                      </div>
                    </div>
                    <CheckboxGridContainer>
                      <div></div>
                      <label>Client</label>
                      <label>Passager</label>
                      <label>Contact dossier</label>
                      {clientNotifications.map(({ label, field }) => (
                        <NotificationLineCheckboxes
                          key={field}
                          provider={provider}
                          label={label}
                          field={field}
                          setProvider={setProvider}
                        />
                      ))}
                    </CheckboxGridContainer>
                    <h4 className="mt-5 mb-4">Personnalisation</h4>
                    <Accordion
                      alwaysOpen
                    >
                      {clientNotifications
                        .map(({ label, field }) => (
                          <Accordion.Item eventKey={field}>
                            <Accordion.Header>{label}</Accordion.Header>
                            <Accordion.Body>
                              <p className="text-muted">
                                {notificationPrefixText[field]}
                              </p>
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="form-label">🇬🇧 Anglais (EN)</label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={
                                      provider?.customization &&
                                      provider.customization[field] &&
                                      typeof provider.customization[field] === 'object'
                                        ? provider.customization[field].EN || defaultNotificationText[field]?.EN || ""
                                        : provider?.customization &&
                                          provider.customization[field] &&
                                          typeof provider.customization[field] === 'string'
                                        ? provider.customization[field]
                                        : defaultNotificationText[field]?.EN || ""
                                    }
                                    onChange={(e) => handleTemplateChange(e, field, "EN")}
                                    placeholder="Enter English text..."
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">🇫🇷 Français (FR)</label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={
                                      provider?.customization &&
                                      provider.customization[field] &&
                                      typeof provider.customization[field] === 'object'
                                        ? provider.customization[field].FR || defaultNotificationText[field]?.FR || ""
                                        : defaultNotificationText[field]?.FR || ""
                                    }
                                    onChange={(e) => handleTemplateChange(e, field, "FR")}
                                    placeholder="Saisir le texte en français..."
                                  />
                                </div>
                              </div>
                              <div className="text-muted mt-4">
                                {notificationSuffixText[field]}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                    </Accordion>
                  </div>
                </div>
              </div>
            )}

            <FooterActionsContainer>
              <div>
                <OutlineButton type="button" onClick={history.goBack}>
                  <i className="fas fa-arrow-left" />
                  Retour
                </OutlineButton>
              </div>
              <div>{buttonText}</div>
              <div>
                {providerId && (
                  <OutlineButton
                    type="button"
                    data-toggle="modal"
                    data-target="#delete_modal"
                  >
                    <i className="fas fa-trash" />
                    Supprimer
                  </OutlineButton>
                )}
              </div>
            </FooterActionsContainer>
          </form>
        </div>
      </div>
      <div
        className="modal fade"
        id="delete_modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Supprimer le client
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Êtes-vous sûr de vouloir supprimer ce client ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleDeleteProvider}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
